<template>
  <div :class="$style.addAircraftOverlay" v-if="isVisible">
    <form :class="$style.addAircraftOverlayPopup" @submit.prevent="submitForm">
      <b :class="$style.addAircraft"
        >{{ isEdit ? "Update" : "Add" }} Aircraft</b
      >
      <div :class="$style.frameParent">
        <div :class="$style.uploadBox" @click="triggerFileInput">
          <input
            type="file"
            ref="fileInput"
            @change="handleFileUpload"
            hidden
            :disabled="submitLoading"
          />
          <div :class="$style.uploadContent">
            <img src="/static/img/upload_blue.svg" alt="" />
            <p>Upload Image</p>
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            gap: 10px;
          "
          v-if="fileName"
        >
          <p style="font-weight: 600; margin-top: 10px">
            Uploaded Image: {{ fileName }}
          </p>
          <span style="color: green; font-size: 16px">✔</span>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Tail Number
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Tail Number..."
              required
              v-model="formData.tailNumber"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Model</div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Model..."
              required
              v-model="formData.model"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Description
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Description..."
              required
              v-model="formData.description"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Home Airport
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Home Airport..."
              required
              v-model="formData.homeAirport"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Aircraft Type
          </div>
          <div class="col-sm-9">
            <hilo-select
              :options="aircraftTypeOptions"
              placeholder="Choose Aircraft Type..."
              theme="grey"
              :searchable="true"
              :customStyle="{
                height: '50px',
                width: '100%',
                padding: '10px',
              }"
              v-model="formData.aircraftTypeId"
              @change="checkAircraftType"
              :disabled="submitLoading"
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Hobbs</div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Hobbs..."
              v-model="formData.hobbs"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Tach</div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Tach..."
              :disabled="isSimulatorType || submitLoading"
              v-model="formData.tach"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Seats</div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Number of seats..."
              v-model="formData.seats"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Fuel Capacity
          </div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Fuel Capacity..."
              v-model="formData.fuelCapacity"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Useful Load
          </div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Useful Load..."
              v-model="formData.usefulLoad"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Empty Weight
          </div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Empty Weight..."
              v-model="formData.emptyWeight"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Max Gross Weight
          </div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Max Gross Weight..."
              v-model="formData.maxGrossWeight"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Moment</div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Moment..."
              v-model="formData.moment"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Primary Color
          </div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Primary Color..."
              v-model="formData.color"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Charge Rate
          </div>
          <div class="col-sm-9">
            <input
              type="number"
              placeholder="Charge Rate..."
              required
              v-model="formData.chargeRate"
              :disabled="submitLoading"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            IFR Certified
          </div>
          <div class="col-sm-9">
            <input
              type="checkbox"
              id="ifrCertified"
              v-model="formData.ifrCertified"
              :disabled="submitLoading"
            />
          </div>
        </div>
      </div>
      <div :class="$style.frameParent7">
        <div :class="$style.saveCloseWrapper" @click="onXClick">
          <b :class="$style.saveClose">Cancel</b>
        </div>
        <div :class="$style.addAircraftTimesWrapper" @click="submitForm">
          <b :class="$style.saveClose"
            >{{ isEdit ? "Update" : "Save" }} Aircraft</b
          >
        </div>
      </div>
      <img
        :class="$style.vectorIcon5"
        alt=""
        src="/static/img/grey-x.svg"
        @click="onXClick"
      />
    </form>

    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import ToastNotifier from "../../../../components/ToastNotifier.vue";
import AircraftAPIService from "src/servicehandlers/AircraftAPIService.js";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
const aircraftAPIService = new AircraftAPIService();

export default defineComponent({
  name: "AddEditAircraft",
  components: {
    HiloSelect,
    ToastNotifier,
  },
  props: {
    isVisible: null,
    aircraft: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      aircraftTypeOptions: [],
      isSimulatorType: null,
      fileName: "",
      initialFormData: {
        tailNumber: "",
        model: "",
        hobbs: "",
        tach: "",
        homeAirport: "",
        description: "",
        seats: "",
        ifrCertified: false,
        fuelCapacity: "",
        usefulLoad: "",
        emptyWeight: "",
        maxGrossWeight: "",
        moment: "",
        color: "",
        image: null,
        chargeRate: "",
        aircraftTypeId: "",
      },
      formData: {},
      submitLoading: false,
    };
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        if (this.aircraft?.image) {
          const parts = this.aircraft?.image.split("/");
          this.fileName = parts[parts.length - 1];
        }
        this.formData = { ...this.aircraft };
        this.checkAircraftType(this.formData.aircraftTypeId);
      }
    },
  },
  async created() {
    this.formData = { ...this.initialFormData };

    await this.getAircraftTypes();
    this.loading = false;
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.formData.image = file;
        this.$forceUpdate();
      }
    },
    async getAircraft(id) {
      try {
        this.formData = await aircraftAPIService.getById(id, this.$router);
        this.checkAircraftType(this.formData.aircraftTypeId);
      } catch (error) {}
    },
    async getAircraftTypes() {
      try {
        this.aircraftTypeOptions = await aircraftAPIService.getAircraftTypes();
      } catch (error) {}
    },
    checkAircraftType(newTypeId) {
      const simulatorType = this.aircraftTypeOptions.find(
        (type) => type.name === "Simulator",
      );
      if (simulatorType?.id === newTypeId) {
        this.formData.tach = "";
        this.isSimulatorType = true;
      } else {
        this.isSimulatorType = false;
      }
    },
    validateForm() {
      const missingFields = [];

      if (!this.formData.tailNumber) {
        missingFields.push("Tail Number");
      }
      if (!this.formData.model) {
        missingFields.push("Model");
      }
      if (!this.formData.description) {
        missingFields.push("Description");
      }
      if (!this.formData.homeAirport) {
        missingFields.push("Home Airport");
      }
      if (!this.formData.aircraftTypeId) {
        missingFields.push("Aircraft Type");
      }
      if (!this.formData.chargeRate) {
        missingFields.push("Charge Rate");
      }

      return missingFields;
    },
    async submitForm() {
      const missingFields = this.validateForm();

      if (missingFields.length) {
        alert(
          `The following fields are required or invalid:\n\n${missingFields.join("\n")}`,
        );
        return;
      }

      try {
        this.submitLoading = true;

        if (this.isEdit) {
          await aircraftAPIService.update(this.aircraft.id, this.formData);
        } else {
          await aircraftAPIService.create(this.formData);
        }

        this.$refs.toast.showSuccess(
          `Aircraft ${this.isEdit ? "updated" : "added"} successfully`,
        );

        this.$emit("save", true);
      } catch (error) {
        this.$refs.toast.showError(
          `Error ${this.isEdit ? "updating" : "creating"} aircraft`,
        );
      } finally {
        this.submitLoading = false;
      }
    },
    onXClick() {
      if (!this.isEdit) {
        this.formData = { ...this.initialFormData };
        this.fileName = "";
        this.isSimulatorType = null;
      }
      this.$emit("close");
    },
  },
});
</script>
<style module scoped>
.uploadBox {
  width: 100%;
  height: 100px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  transition: border 0.3s ease;
}

.uploadBox:hover {
  border-color: #3c74fd;
}

.uploadContent {
  color: #3c74fd;
  font-size: 16px;
}

.uploadContent svg {
  margin-bottom: 5px;
}
.addAircraftOverlayPopup {
  height: 90%;
  width: 50%;
  max-width: 730px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin: auto;
  overflow-y: scroll;
}
.addAircraftOverlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 500px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
  overflow-y: scroll;
}
.addAircraft {
  position: relative;
  font-size: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 2;
}
.saveClose {
  position: relative;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.saveCloseWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: rgba(64, 64, 64, 0.25);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}
.addAircraftTimesWrapper {
  flex: 1;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  color: #fff;
}
.frameParent7 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  cursor: pointer;
  z-index: 20;
  text-align: center;
}
.vectorIcon5 {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 47px;
  right: 51px;
  height: 12px;
  z-index: 21;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  margin-top: 5px;
}
</style>
